import { createFileRoute } from '@tanstack/react-router';
import { SignalsSettingsPage } from '../components/signals/signal-subscriptions-settings.js';

export const Route = createFileRoute('/$workspaceSlug/settings/signals')({
  component: SignalsSettingsPage,
});
